import ResetIcon from '@app/component/icon/ResetIcon';
import FormButton from '@app/component/form/button/FormButton';
import React from 'react';
import { useReviewsTools } from '@app/site/secured/review-manager/provider/useReviewsTools';


const ReviewsFilterResetButton = React.memo(() => {

	const tools = useReviewsTools()

	return <FormButton state="white" extraClassName="text-xs h-8 w-6"
										 onClick={tools.reset}>
		<ResetIcon className="h-3 w-3 fill-current flex-shrink-0" />
	</FormButton>;
});

export default ReviewsFilterResetButton;